import { type FC, type PropsWithChildren } from 'react'
import classNames from 'classnames'
import { Button } from '../../../components/Button/Button'
import { WARNING_BORDER } from '../constants'

interface AccountRowShellProps extends PropsWithChildren {
  heading: string
  subheading?: string
  complete: boolean
  confirmed: boolean
  readOnly: boolean
  expanded: boolean
  onToggleExpand: () => void
}

export const AccountRowShell: FC<AccountRowShellProps> = ({ heading, subheading, complete, confirmed, readOnly, expanded, onToggleExpand, children }) => {
  const marked = !expanded && !readOnly && !complete

  return (
    <div className={classNames('rounded-3 p-3 d-flex flex-column zocks-gap-1.5', marked ? WARNING_BORDER : 'border zocks-border-color-gray-300')}>
      <div className='d-flex align-items-center justify-content-between zocks-gap-1.5'>
        <div className='d-flex flex-column zocks-gap-0.5'>
          <div className='d-flex align-items-center zocks-gap-0.5'>
            <i className='bi bi-person' />
            <span className='paragraph-medium medium'>{heading}</span>
          </div>
          {subheading ? (
            <div className='d-flex align-items-center zocks-gap-0.5'>
              <i className='bi bi-diagram-3 zocks-text-gray-600' />
              <span className='paragraph-medium zocks-text-gray-600'>{subheading}</span>
            </div>
          ) : null}
        </div>
        {readOnly ? null : (
          <div className='d-flex align-items-center zocks-gap-0.5 flex-fill'>
            <i className={classNames('fs-5', confirmed ? 'bi bi-file-earmark-check zocks-text-success' : 'bi bi-search')} />
            <span className={classNames('paragraph-medium medium', { 'zocks-text-success': confirmed })}>{confirmed ? 'Reviewed' : 'Ready to review'}</span>
          </div>
        )}
        <Button variant='secondary' className='d-flex align-items-center zocks-gap-0.5 flex-shrink-0' onClick={onToggleExpand}>
          <i className={classNames('bi', expanded ? 'bi-x-lg' : 'bi-eye')} />
          {expanded ? 'Close' : confirmed || readOnly ? 'View' : 'Review'}
        </Button>
      </div>

      {expanded ? <div className='d-flex flex-column zocks-gap-1'>{children}</div> : null}
    </div>
  )
}
